import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Typography, Button, Box } from '@mui/material';

function LogoutSuccess() {
    const navigate = useNavigate();

    useEffect(() => {
        // Automatically redirect to login after 3 seconds
        const timer = setTimeout(() => {
            navigate('/login');
        }, 3000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#1a1a1a'
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    textAlign: 'center',
                    maxWidth: 400,
                    bgcolor: '#202020',
                    color: '#ffffff'
                }}
            >
                <Typography variant="h5" gutterBottom>
                    👋 You've been logged out
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    Thank you for using The Climate Spectrum
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate('/login')}
                >
                    Log in again
                </Button>
            </Paper>
        </Box>
    );
}

export default LogoutSuccess;